import { Field } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { ModelState } from "../../../interfaces/modelState";
import { InsuredPerson } from "../../../providers/dlpFlow/DlpFlow.interfaces";
import { Card } from "../../card/Card";
import useFieldData from "../../InputFields/useFieldData";
import { V7 } from "../../InputFields/validator/validators";
import { RadioOption, VerticalRadioInput } from "../../InputFields/VerticalRadioInput";
import { Tooltip } from "../../tooltip/Tooltip";

interface Props {
  fields: Record<string, Field<string>>;
  index: number;
  modelState: ModelState | null;
  setModelState: (modelState: ModelState) => void;
  id?: string;
  name: string;
  fieldName: string;
  insureds?: string[];
  validationPropertyName: string;
  onUpdateInsuredPersonsIds: (insuredIds: string[]) => void;
  insuredPersons: Partial<InsuredPerson>[];
}

export const Insureds = ({
  onUpdateInsuredPersonsIds,
  validationPropertyName,
  fields,
  insureds,
  index,
  fieldName,
  id: idProp,
  name,
  modelState,
  setModelState,
  insuredPersons,
}: Props) => {
  const firstInsured = insuredPersons[0];
  const secondInsured = insuredPersons[1];

  const inputValue = JSON.stringify(insureds ? insureds : []);
  const { heading, placeholder, tooltip } = useFieldData(fields, name);
  const value1 = JSON.stringify([firstInsured.personId]);
  const value2 = JSON.stringify([secondInsured.personId]);
  const value12 = JSON.stringify([firstInsured.personId, secondInsured.personId]);

  const insuredOptions = [
    { label: firstInsured.firstName, value: value1 },
    { label: secondInsured.firstName, value: value2 },
    {
      label: firstInsured.firstName + " en " + secondInsured.firstName,
      value: value12,
    },
  ] as RadioOption<string>[];

  const onFieldChange = (fieldValue: string) => {
    const personsIds = JSON.parse(fieldValue) as string[];
    onUpdateInsuredPersonsIds(personsIds);
  };

  const id = idProp || fieldName;
  const headingId = `${id}-heading`;

  return (
    <Card>
      <h2 id={headingId}>{heading.value}</h2>
      <div className="form-item">
        <div className="form-input">
          <div className="form-label">
            {placeholder.value}
            <Tooltip fieldName={name} value={tooltip.value} />
          </div>
        </div>
      </div>
      <VerticalRadioInput
        required
        wrapOptionInDiv="No"
        selectedRadioItem={inputValue}
        validators={[V7]}
        propertyName={validationPropertyName}
        onChange={onFieldChange}
        name={`${name + index}`}
        options={insuredOptions}
        modelState={modelState}
        setModelState={setModelState}
        ariaLabelledBy={headingId}
      />
    </Card>
  );
};
